import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropZoneModule } from '../drop-zone/drop-zone.module';
import { DemoPrescriptionComponent } from './demo-prescription/demo-prescription.component';
import { UploadPrescriptionPopupComponent } from './upload-prescription-popup.component';
import { AddressModule } from '../address/address.module';
import {MaterialModule} from "../../../material/material.module";
import {ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    UploadPrescriptionPopupComponent,
    DemoPrescriptionComponent
  ],
  imports: [
    CommonModule,
    DropZoneModule,
    AddressModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  exports: [
    UploadPrescriptionPopupComponent
  ]
})
export class UploadPrescriptionPopupModule { }
